export default function currencyFormatting(amount: any) {
    let amtNumber = Number(amount);

    if (isNaN(amtNumber)) {
        return '';
    }

    let numberWithCommas = (num: number) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let currSign = '$';
    let amtString = numberWithCommas(Math.abs(amtNumber));

    return amtNumber < 0 ? `-${currSign}${amtString}` : `${currSign}${amtString}`;
}